import { Component, OnInit, inject } from '@angular/core';
import { User } from '../../../core/models/user.model';
import { UsersService } from '../../../core/services/users.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserFormMode, UserFormComponent } from '../../components/user-form/user-form.component';
import { HttpErrorResponse } from '@angular/common/http';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';
import { UserType } from 'app/core/enums/user-type.enum';
import { AuthenticationService } from 'app/core/services/authentication.service';

import { UserHeaderComponent } from '../../components/user-header/user-header.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-user-edit',
    templateUrl: './capture-admin-user-edit.component.html',
    styleUrls: ['./capture-admin-user-edit.component.scss'],
    imports: [UserHeaderComponent, UserFormComponent, MatProgressSpinner]
})
export class CaptureAdminUserEditComponent implements OnInit {
  private usersService = inject(UsersService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthenticationService);

  user: User;
  loading = false;
  formModes = UserFormMode;

  ngOnInit() {
    this.init();
  }

  private init() {
    const userId = this.route.snapshot.paramMap.get('id');
    this.loadUser(userId);
  }

  private loadUser(userId): void {
    this.loading = true;
    this.usersService.get(userId).subscribe(
      user => {
        this.user = user;
        if (this.canManage) {
          this.loading = false;
        } else {
          this.router.navigate(['/404'], { replaceUrl: true });
        }
      },
      (err: HttpErrorResponse) => {
        if (err.status === 404) {
          this.router.navigate(['/404'], { replaceUrl: true });
        } else {
          console.error(err);
        }
      }
    );
  }

  private get isAdminUser() {
    return this.user.userType === UserType.captureAdmin || this.user.userType === UserType.llmPlaygroundUser;
  }

  private get canManage() {
    return (this.isAdminUser && this.authService.hasPermissionTo(UserRoleName.manageCaptureAdmin)) ||
      !this.isAdminUser && this.authService.hasPermissionTo(UserRoleName.manageUsers);
  }
}
